// // create a container and set the full-size image as its background
// function createOverlay(image) {
//   const overlayImage = document.createElement('img');
//   overlayImage.setAttribute('src', `${image.src}`);
//   overlay = document.createElement('div');
//   prepareOverlay(overlay, overlayImage);

//   image.style.opacity = '50%';
//   toggleLoadingSpinner(image);

//   overlayImage.onload = () => {
//     toggleLoadingSpinner(image);
//     image.parentElement.insertBefore(overlay, image);
//     image.style.opacity = '100%';
//   };

//   return overlay;
// }

// function prepareOverlay(container, image) {
//   container.setAttribute('class', 'image-magnify-full-size');
//   container.setAttribute('aria-hidden', 'true');
//   container.style.backgroundImage = `url('${image.src}')`;
//   container.style.backgroundColor = 'var(--gradient-background)';
// }

// function toggleLoadingSpinner(image) {
//   const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
//   loadingSpinner.classList.toggle('hidden');
// }

// function moveWithHover(image, event, zoomRatio) {
//   // calculate mouse position
//   const ratio = image.height / image.width;
//   const container = event.target.getBoundingClientRect();
//   const xPosition = event.clientX - container.left;
//   const yPosition = event.clientY - container.top;
//   const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
//   const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

//   // determine what to show in the frame
//   overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
//   overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
// }

// function magnify(image, zoomRatio) {
//   const overlay = createOverlay(image);
//   overlay.onclick = () => overlay.remove();
//   overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
//   overlay.onmouseleave = () => overlay.remove();
// }

// function enableZoomOnHover(zoomRatio) {
//   const images = document.querySelectorAll('.image-magnify-hover');
//   images.forEach((image) => {
//     image.onclick = (event) => {
//       magnify(image, zoomRatio);
//       moveWithHover(image, event, zoomRatio);
//     };
//   });
// }

// enableZoomOnHover(2);


function createOverlay(image) {
  const container = image.parentElement;
  container.style.position = 'relative';

  // Create magnified view (shown on right side)
  const overlay = document.createElement('div');
  overlay.classList.add('image-magnify-full-size');
  overlay.style.position = 'absolute';
  overlay.style.top = '0';
  overlay.style.left = '100%';
  overlay.style.width = '(100 / 2) + "%"';
  overlay.style.height = `${image.height}px`;
  overlay.style.marginLeft = '10px';
  overlay.style.backgroundImage = `url('${image.src}')`;
  overlay.style.backgroundRepeat = 'no-repeat';
  overlay.style.backgroundSize = `${image.width * 2}px ${image.height * 2}px`;
  overlay.style.pointerEvents = 'none';
  overlay.style.boxShadow = '0 0 5px rgba(0,0,0,.1)';
  overlay.style.display = 'none';
  container.appendChild(overlay);

  // Create lens
  const lens = document.createElement('div');
  lens.classList.add('image-magnify-lens');
  lens.style.position = 'absolute';
  lens.style.border = '2px solid #000';
  lens.style.background = 'rgba(255, 255, 255, 0.3)';
  lens.style.pointerEvents = 'none';
  lens.style.display = 'none';
  container.appendChild(lens);

  return { overlay, lens };
}

function moveWithHover(image, event, overlay, lens, zoomRatio) {
  const rect = image.getBoundingClientRect();
  const offsetX = event.clientX - rect.left;
  const offsetY = event.clientY - rect.top;

  const lensWidth = 300;
  const lensHeight = 300;

  let lensX = offsetX - lensWidth / 2;
  let lensY = offsetY - lensHeight / 2;

  // Keep lens within bounds
  lensX = Math.max(0, Math.min(image.width - lensWidth, lensX));
  lensY = Math.max(0, Math.min(image.height - lensHeight, lensY));

  lens.style.left = `${lensX}px`;
  lens.style.top = `${lensY}px`;
  lens.style.width = `${lensWidth}px`;
  lens.style.height = `${lensHeight}px`;

  // Calculate zoomed background position
  const bgX = (lensX / image.width) * (image.width * zoomRatio);
  const bgY = (lensY / image.height) * (image.height * zoomRatio);
  overlay.style.backgroundSize = `${image.width * zoomRatio}px ${image.height * zoomRatio}px`;
  overlay.style.backgroundPosition = `-${bgX}px -${bgY}px`;
}

function enableZoomOnHover(zoomRatio = 2) {
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    const { overlay, lens } = createOverlay(image);

    image.addEventListener('mouseenter', () => {
      overlay.style.display = 'block';
      lens.style.display = 'block';
    });

    image.addEventListener('mousemove', (event) => {
      moveWithHover(image, event, overlay, lens, zoomRatio);
    });

    image.addEventListener('mouseleave', () => {
      overlay.style.display = 'none';
      lens.style.display = 'none';
    });
  });
}

// Activate zoom on hover
enableZoomOnHover(2);
